export const Types = {
  GET_REQUEST: 'states/GET_REQUEST',
  GET_SUCCESS: 'states/GET_SUCCESS',
};

const INITIAL_STATE = {
  states: [],
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.GET_REQUEST:
      return { ...state, loading: true };
    case Types.GET_SUCCESS:
      if (action.payload.data === null) {
        return state;
      }
      return { states: action.payload.data, loading: false, error: null };
    default:
      return state;
  }
};

export const Creators = {
  getStatesRequest: () => ({ type: Types.GET_REQUEST }),
  getStatesSuccess: data => ({
    type: Types.GET_SUCCESS,
    payload: { data },
  }),
};



// WEBPACK FOOTER //
// ./src/store/ducks/states.js